import { createFileRoute } from '@tanstack/react-router'
import { OnlineApplicationScreen } from '@/features/online-application/online-application-screen'

/**
 * The public application page (design "The public routes", ADR-0022). A
 * top-level route outside the authenticated layout, like
 * `apps/company/src/routes/kiosk.tsx` — no app menus, no session call.
 */
export const Route = createFileRoute('/apply/$token')({
  component: ApplyRoute,
})

function ApplyRoute() {
  const { token } = Route.useParams()
  return <OnlineApplicationScreen token={token} />
}
